import { Moon, Sun } from 'lucide-react';

import { useTemaActual as useTema } from '@/lib/TemaProvider';
import { cn } from '@/lib/utils';

/** Selector ☀/☾ (skill §0.2): oscuro por omisión, preferencia guardada en el navegador. */
export function SelectorTema({ className }: { className?: string }) {
  const { tema, alternar } = useTema();
  return (
    <button
      type="button"
      className={cn('selector-tema', className)}
      onClick={alternar}
      aria-label={tema === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      title={tema === 'dark' ? 'Tema claro' : 'Tema oscuro'}
    >
      {tema === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
